var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { LoginComponent } from '../../shared/auth/login/login.component';
import { LoginService } from '../../shared/auth/login/login.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../shared/auth/auth.service';
import { Principal } from '../../shared/auth/principal.service';
import { SnackBarService } from '../../shared/services/snackbar.service';
import { GlobalSpinnerService } from '../../shared/components/loader-service/global-spinner.service';
var PublisherLoginComponent = /** @class */ (function (_super) {
    __extends(PublisherLoginComponent, _super);
    function PublisherLoginComponent(loginService, router, route, authService, principal, snackBarService, globalSpinnerService) {
        var _this = _super.call(this, loginService, router, route, authService, principal, snackBarService, globalSpinnerService) || this;
        _this.registerLinkVisible = true;
        _this.termsAndConditions = true;
        return _this;
    }
    PublisherLoginComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    return PublisherLoginComponent;
}(LoginComponent));
export { PublisherLoginComponent };
